import { render, staticRenderFns } from "./NewEditPeriodoPage.vue?vue&type=template&id=04262c62"
import script from "./NewEditPeriodoPage.vue?vue&type=script&lang=js"
export * from "./NewEditPeriodoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports